// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__ssNml","spinner":"Spinner_spinner__MrWKw","spinner__icon":"Spinner_spinner__icon__Ne82p"};